import { __assign } from "tslib";
// DS: i3.12
import React from 'react';
import IconWrap from '../../IconWrap';
var GiveBadge = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M13.06 1.49A1 1 0 0012.2 1H3.33a1 1 0 00-.86.49L.14 5.37a1 1 0 00.11 1.18l6.77 7.6.08.1a1 1 0 001.41-.1l1.18-1.32-.7-.7-1.23 1.36L1 5.9 3.33 2h8.87l2.33 3.88-1.11 1.25.7.71 1.16-1.3a1 1 0 00.1-1.17l-2.32-3.88zm-1.3 6.01a.5.5 0 00-1 0V9h-1.5a.5.5 0 000 1h1.5v1.5a.5.5 0 001 0V10h1.5a.5.5 0 000-1h-1.5V7.5z" }))));
};
GiveBadge.displayName = 'GiveBadge';
export default GiveBadge;
//# sourceMappingURL=GiveBadge.js.map